import { resolveSupportedLanguage as resolveLanguage } from '@dec/shared/utils/languages';

import { translationResources } from './resources';

export const fallbackLanguage = 'en';

export const supportedLanguages = Object.keys(translationResources);

export function resolveSupportedLanguage(value?: string | null): string {
  return resolveLanguage(value, fallbackLanguage);
}
